import styled from "styled-components";
import { slideInBottom } from "../styled/animations";
import CryptidCard from "./cryptidCard";
import { useSwipeable } from "react-swipeable";
import { useDeck } from "../../context/DeckContext";

const AddToSlot = (props) => {
    const {card ,open,setOpen,inSlot} = props;
    const {updateUserSlots,slots} = useDeck();
    const handleSwipe = async (direction) => {
        if(direction === "up" && !inSlot){
            const slotCardIds = slots.map(slot => slot?._id);
            if(slotCardIds.includes(card._id)){
                alert("Card already in your slot");
                setOpen(false);
                return;
            }
            await updateUserSlots([...slotCardIds,card._id]);
            setTimeout(() => {
                setOpen(false);
            }
            , 300);
        }else{
            setOpen(false);
        }
        
    }
    const handlers = useSwipeable({
    onSwipedUp: () => handleSwipe("up"),
    onSwipedDown: () => handleSwipe("down"),
    preventDefaultTouchmoveEvent: true,
    trackMouse: true,
    delta: 50, // Yanlışlıkla kaydırmayı önlemek için eşik değer
    });
    if(!open) return null;
    return (
        <SlotContainer  {...handlers} >
            <BlurredContainer/>
                    <CryptidCardContainer>
                        <CryptidCard cryptid={card}/>
                    </CryptidCardContainer> 
                    {inSlot ? <StyledText>Selected Card in  your slot. Swipe down to close</StyledText> :
                    <StyledText>Swipe up add to slot</StyledText>
                    }
                    
        </SlotContainer>
    );
}

const SlotContainer = styled.div`
    width: 100%;
    height: 100%;
    bottom: 0;
    left: 0;
    z-index: 100;
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    touch-action: pan-x;
    `
const BlurredContainer = styled.div`
  background: #2828284D;
  position: absolute;
  bottom: 0;
  border: 1px solid #7455BF;
  border-top-left-radius: 30px;
  border-top-right-radius: 30px;
  height: 40vh;
  box-shadow: 0px -13px 65px 0px rgba(116,85,191,0.51);
  backdrop-filter: blur(50px);
  -webkit-backdrop-filter: blur(50px);
  width: 100%;
  max-width:420px;
  animation: ${slideInBottom} 0.3s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
`
const CryptidCardContainer = styled.div`
    position: absolute;
    width: 50%;
    max-width: 182px;
    margin-top:20%;
    height:auto;
    aspect-ratio: 859/1320;
    animation: ${slideInBottom} 0.5s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
`
const StyledText = styled.p`
     text-align: center;
     padding: 0 16px;
    font-size: 1em;
    font-weight: 700;
    color: ${(props) => props.theme.colors.text.light};
    margin: 0;
    text-shadow: 4px 4px 24px rgba(255, 255, 255, 0.34);
    position: absolute;
    bottom: 10%;
    width: 100%;
    max-width: 420px;
`
export default AddToSlot;